import ScheduleTourForm from '@/components/ScheduleTourForm/ScheduleTourForm';
import ScheduleTourPropertyDetails from '@/components/ScheduleTourPropertyDetails/ScheduleTourPropertyDetails';
import type { Unit } from '@/domain/units';
import { getApplyNowLink } from '@/utils/links';
import { type FC } from 'react';

interface Props {
  unit: Unit;
}

const ApplyFormCard: FC<Props> = ({ unit }) => {
  return (
    <div className="bg-white p-8 rounded-none border border-gray-200">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Rental Application</h2>

      <ScheduleTourPropertyDetails unitId={unit.id} />

      <ScheduleTourForm
        getRedirectTo={(u, lead) => getApplyNowLink(u.id, lead)}
        submitButtonText="Apply Now"
        unit={unit}
        showDisclaimer
      />
    </div>
  );
};

export default ApplyFormCard;
